import { type ResultOf } from '@graphql-typed-document-node/core';
import { graphql } from '@mp/graphql/generated';
import { useGraphQLQuery } from './useGraphQLRequest';

const PoolForOnboardingGql = graphql(`
  query GetPoolForOnboarding($id: Int!) {
    pool(id: $id) {
      id
      location {
        id
      }
      positions {
        id
      }
    }
  }
`);

type PoolForOnboardingResult = ResultOf<typeof PoolForOnboardingGql>;

export type UsePoolResult = {
  locationId: number | undefined;
  positionIds: string | undefined;
  isLoading: boolean;
};

export const usePool = (poolId: number | null | undefined): UsePoolResult => {
  const enabled = poolId !== null && poolId !== undefined;

  const { data, isLoading, isInitialLoading } = useGraphQLQuery<PoolForOnboardingResult>({
    enabled,
    operationName: 'GetPoolForOnboarding',
    query: PoolForOnboardingGql,
    variables: {
      id: poolId ?? 0,
    },
  });

  const pool = data?.pool;
  const positions = pool?.positions ?? [];
  const positionIds = positions.length
    ? positions.map((position) => position.id).join(',')
    : undefined;

  return {
    locationId: pool?.location?.id,
    positionIds,
    isLoading: enabled ? isLoading : isInitialLoading,
  };
};
